import { useQuery } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useTeamAssignments = (config) => {
  return useQuery({
    ...config,
    queryKey: "team-assignments",
    queryFn: ({ signal }) =>
      fetch({
        url: `${Angie.api_url}/teams/assignments`,
        signal,
      }),
  });
};

export const useTeamAvailability = (teamId, config) => {
  return useQuery({
    ...config,
    queryKey: `teams-${teamId}-availability-records`,
    queryFn: ({ signal }) =>
      fetch({
        url: `${Angie.api_url}/availability-records/teams/${teamId}`,
        signal,
      }),
  });
};
